import { BarcodeOutlined, FileTextOutlined } from '@ant-design/icons';
import { Modal, Space } from 'antd';
import { useCallback, useEffect, useRef, useState } from 'react';
import { generateBill } from '../pdf/generateBill';
import { generateTransactionBill } from '../pdf/generateTransactionBill';
import PRNSelectPrintFormat from './PRNSelectPrintFormt';
import { ShowDataById } from '@/apiError/apiShowById';
import { PrintFormatRenderer } from '@/features/format-designer/PrintFormatRenderer';
import { getPrintFormatFromTemplate } from '@/utils/transaction/jewelry-new-sticker/buildBillTemplatePayload';
import { BillPrintMapper } from '@/utils/transaction/jewelry-new-sticker/mapper/bill';
import {
  mapAppToBusiness,
  mapRawSummaryToTokenContext,
} from '@/shared/utils/invoiceMapper';
import useAppData from '@/hooks/useAppData';
import { useReactToPrint } from 'react-to-print';
import { useUpdateApi, useUpdateApiNoToast } from '@/apiError/apiUpdate';
import { useTransactionContext } from '@/context/TransactionContext';
import GahanaPurchaseReceipt from '@/utils/transactionbill/GahanaPurchaseReceipt';

const NewTransactionSubmitModal = ({
  visible,
  onClose,
  onGenerateBill,
  onSave,
  barcodeValues = [],
  formReport,
  hideBarCode = false,
  tableData = [],
  columns = [],
  date,
  title,
  voucherNumber,
  paidTo,
  totalDrAmount,
  totalCrAmount,
  from = '',
  party,
  billNumber,
  navigate = () => {},
  extraDetails,
  setExtraDetails,
  billTemplateData,
  showPurchaseReceipt = false,
  purchaseReceiptCustomer,
  purchaseReceiptRows,
  printReturnUrl,
}) => {
  const [selectBarcodeFormatModal, setSelectBarcodeFormatModal] =
    useState(false);
  const [dataToPut, setDataToPut] = useState();
  useEffect(() => {
    const fetchDataById = async (referenceId) => {
      if (referenceId) {
        const response = await ShowDataById.getDataById(
          `/account/ledger/${referenceId}/`,
          navigate,
        );
        setDataToPut(response?.data);
      }
    };
    fetchDataById(billNumber?.ledgerId);
  }, [billNumber]);

  const componentRef = useRef(null);
  const { app } = useAppData();

  const { setBillTemplate, setBillPrintUrls } = useTransactionContext();

  const handleOnBeforeGetContent = useCallback(() => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, 10);
    });
  }, []);

  const handleBeforePrint = useCallback(() => {});

  const printTemplate = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: '\u00A0',
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    removeAfterPrint: true,
  });

  const { mutate: incrementPrint } = useUpdateApiNoToast();

  const purchaseReceiptRef = useRef(null);
  const printPurchaseReceipt = useReactToPrint({
    content: () => purchaseReceiptRef.current,
    documentTitle: '\u00A0',
    onBeforeGetContent: handleOnBeforeGetContent,
    removeAfterPrint: true,
  });

  const purchaseData = extraDetails?.summaryData?.purchaseData;
  const purchaseRows = purchaseReceiptRows?.length
    ? purchaseReceiptRows
    : (purchaseData?.detailsData || []).map((row) => ({
        id: row?.referenceId,
        itemName: row?.itemName,
        grossWeight: row?.grossWeight ?? row?.netWeight,
        purity: row?.purity,
        pureWeight: row?.pureWeight,
        rate: row?.rate,
        amount: row?.subTotal ?? row?.netAmount,
      }));
  const hasPurchaseReceipt = showPurchaseReceipt && purchaseRows.length > 0;

  return (
    <Modal
      title="Transaction Options"
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
    >
      <Space
        direction="horizontal"
        style={{
          width: '100%',
          justifyContent: 'space-around',
        }}
      >
        {hideBarCode ? (
          ''
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              transition: 'all 0.3s',
              cursor: 'pointer',
            }}
            onClick={() => {
              setSelectBarcodeFormatModal(true);
            }}
          >
            <div
              style={{
                width: 100,
                height: 100,
                borderRadius: '50%',
                backgroundColor: 'brown',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <BarcodeOutlined style={{ color: 'white', fontSize: 24 }} />
            </div>
            <span>Print Barcodes</span>
          </div>
        )}

        {formReport ? (
          ''
        ) : (
          <>
            {/* <div
              style={{
                display: 'hidden',
                flexDirection: 'column',
                alignItems: 'center',
                transition: 'all 0.3s',
                cursor: 'pointer',
              }}
              onClick={() =>
                from === 'transaction'
                  ? generateTransactionBill(
                      tableData,
                      columns,
                      date,
                      title,
                      voucherNumber,
                      party,
                      billNumber,
                      dataToPut,
                      extraDetails,
                    )
                  : generateBill(
                      tableData,
                      columns,
                      date,
                      title,
                      voucherNumber,
                      paidTo,
                      totalDrAmount,
                      totalCrAmount,
                    )
              }
            >
              <div
                style={{
                  width: 100,
                  height: 100,
                  borderRadius: '50%',
                  backgroundColor: '#1890ff',
                  display: 'hidden',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <FileTextOutlined style={{ color: 'white', fontSize: 24 }} />
              </div>
              <span className="hidden">Generate Bill</span>
            </div> */}

            <div>
              <div className="tw-flex tw-flex-col tw-items-center tw-space-y-2">
                <div
                  className="tw-w-24 tw-h-24 tw-rounded-full tw-bg-blue-600 tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-shadow-lg hover:tw-bg-blue-700 tw-transition-all tw-duration-300"
                  onClick={() => {
                    if (title === 'Sales') {
                      setBillPrintUrls((prev) => ({
                        ...prev,
                        DATA_URL: `/transaction/sale/${extraDetails?.summaryData?.referenceId}/?mode=print`,
                        BILL_SETUP_URL:
                          '/transaction/bill-setup/transaction-type/sales/',
                        RETURN_URL: printReturnUrl,
                      }));
                      setBillTemplate(true);
                      navigate('/print-preview/');
                    }
                    if (extraDetails?.customerDetails?.referenceId) {
                      incrementPrint({
                        url: `/transaction/sales/${extraDetails?.customerDetails?.referenceId}/increment-print/`,
                      });
                    }
                    printTemplate();
                  }}
                >
                  <FileTextOutlined className="tw-text-white tw-text-3xl" />
                </div>
                <span className="tw-text-sm tw-font-medium tw-text-gray-700">
                  Print Bill
                </span>
              </div>
            </div>
            {hasPurchaseReceipt && (
              <div>
                <div className="tw-flex tw-flex-col tw-items-center tw-space-y-2">
                  <div
                    className="tw-w-24 tw-h-24 tw-rounded-full tw-bg-amber-600 tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-shadow-lg hover:tw-bg-amber-700 tw-transition-all tw-duration-300"
                    onClick={() => printPurchaseReceipt()}
                  >
                    <FileTextOutlined className="tw-text-white tw-text-3xl" />
                  </div>
                  <span className="tw-text-sm tw-font-medium tw-text-gray-700">
                    Purchase Receipt
                  </span>
                </div>
              </div>
            )}
            {/* <div
              onClick={navigate}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                transition: 'all 0.3s',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  width: 100,
                  height: 100,
                  borderRadius: '50%',
                  backgroundColor: '#52c41a',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <SaveOutlined style={{ color: 'white', fontSize: 24 }} />
              </div>
              <span>Save Transaction</span>
            </div> */}
          </>
        )}
      </Space>

      {(() => {
        const printFormat = getPrintFormatFromTemplate(
          billTemplateData?.editorConfig,
          billTemplateData?.configuration,
        );
        if (printFormat) {
          return (
            <div style={{ position: 'fixed', left: '-9999px', top: 0 }}>
              <PrintFormatRenderer
                ref={componentRef}
                printFormat={printFormat}
                tokenCtx={mapRawSummaryToTokenContext(
                  extraDetails?.summaryData,
                  extraDetails?.detailsData,
                  mapAppToBusiness(app),
                  extraDetails?.goldRateInTola,
                  extraDetails?.silverRateInTola,
                )}
              />
            </div>
          );
        }
        if (
          billTemplateData?.editorConfig &&
          billTemplateData?.contentBlocks?.length
        ) {
          return (
            <div style={{ position: 'fixed', left: '-9999px', top: 0 }}>
              <BillPrintMapper
                ref={componentRef}
                data={extraDetails}
                blocks={billTemplateData.contentBlocks}
                editorConfig={billTemplateData.editorConfig}
                copies={[]}
                isHidden={false}
              />
            </div>
          );
        }
        return null;
      })()}
      {hasPurchaseReceipt && (
        <div style={{ position: 'fixed', left: '-9999px', top: 0 }}>
          <GahanaPurchaseReceipt
            ref={purchaseReceiptRef}
            business={mapAppToBusiness(app)}
            purchase={{ rows: purchaseRows }}
            customer={purchaseReceiptCustomer}
            receiptNo={
              purchaseData?.summaryData?.billNumber ||
              extraDetails?.summaryData?.billNumber
            }
            date={
              purchaseData?.summaryData?.purchaseDate ||
              extraDetails?.summaryData?.salesDate
            }
          />
        </div>
      )}
      <PRNSelectPrintFormat
        hideBarCode={hideBarCode}
        visible={selectBarcodeFormatModal}
        onClose={() => {
          setSelectBarcodeFormatModal(false);
          setTimeout(() => {
            onClose();
          }, 500);
        }}
        setSelectBarcodeFormatModal={setSelectBarcodeFormatModal}
        closeTransactionModal={onClose}
        extraDetails={extraDetails?.detailsData}
        summaryData={extraDetails?.summaryData}
        formReport={formReport}
        barcodeValues={barcodeValues}
        setExtraDetails={setExtraDetails}
      />
    </Modal>
  );
};

export default NewTransactionSubmitModal;
